import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSnapCursorToIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 3.5,
			transform: "translate(-.296)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 9,
			strokeOpacity: .4,
			transform: "translate(-.296)"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M17.72 15.575 21.297 12l-3.5-3.5M21.296 12h-6.092" })
	]
});
export default SvgSnapCursorToIcon;
